import { render, staticRenderFns } from "./TemplateImport.vue?vue&type=template&id=46f9b031&scoped=true"
import script from "./TemplateImport.vue?vue&type=script&lang=js"
export * from "./TemplateImport.vue?vue&type=script&lang=js"
import style0 from "./TemplateImport.vue?vue&type=style&index=0&id=46f9b031&scoped=true&lang=css"
import style1 from "./TemplateImport.vue?vue&type=style&index=1&id=46f9b031&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f9b031",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f9b031')) {
      api.createRecord('46f9b031', component.options)
    } else {
      api.reload('46f9b031', component.options)
    }
    module.hot.accept("./TemplateImport.vue?vue&type=template&id=46f9b031&scoped=true", function () {
      api.rerender('46f9b031', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/template/component/TemplateImport.vue"
export default component.exports